const prefix = "[@unimed/spa]";

export default {
  not_loaded: module =>
    `${prefix}: Não foi possivel carregar o módulo '${module}'`,
  not_found: module =>
    `${prefix}: Não foi possivel encontrar o módulo '${module}'`,
  not_render: module => `${prefix}: O módulo '${module}' não foi renderizado`
};
